import { 
  REMOTE_CONFIG_DEFAULT_KEY_VALUES
} from "../../api/firebase/remote-config";


// REMOTE_CONFIG_KEYS.FLAG_B is only an example value. Not to actually be used anywhere. 
const initialState = {
  remoteConfig: {
    ...REMOTE_CONFIG_DEFAULT_KEY_VALUES
  }
};

export const FIREBASE_REDUCER_TYPES = {
  SET_REMOTE_CONFIG_FLAG: "SET_REMOTE_CONFIG_FLAG"
};

export const firebase = (state = initialState, action) => {
  const { type, payload } = action;
  const { SET_REMOTE_CONFIG_FLAG } = FIREBASE_REDUCER_TYPES;

  // Each time a new flag is added, add it here to transform how you want that value
  // to appear in the state flag
  switch(type){
    case SET_REMOTE_CONFIG_FLAG:
      return { 
        ...state, 
        remoteConfig: {
          ...state.remoteConfig,
          [payload.flagKey]: payload.flagValue 
        }
      };
    default: 
      return state;
  }
}